import React, {useState, useEffect, useContext} from "react";
import EditablePdf from "../../../components/forms/EditablePdf";
import {Grid, Col} from "../../../styles/Grid";
import styled from "styled-components";
import SessionGenerator from "./sessions/SessionGenerator";
import {Input, Label} from "../../../components/forms/DynamicInput";
import EditableImg from "../../../components/forms/EditableImg";
import {AppButton, ResetButton} from "../../../styles/Butttons";
import nextId from "react-id-generator";
import MediaCreator from "./media/MediaCreator";
import {
   CreateResourceCourse,
   CreateThemeCourse,
   CreateSubthemeCourse,
   UpdateThemeCourse,
   UpdateSubthemeCourse,
} from "../../../services/GeneralServices";
import AppLoader, {StatusLoader} from "../../../components/loaders/Loader";
import SessionsList from "./sessions/SessionsList";
import {ReactComponent as PlusIcon} from "../../../assets/icons/plus.svg";
import Color from "../../../assets/colors";
import {useHistory, useParams} from "react-router-dom";
import {EditCourseContext} from "../../../context/EditCourseProvider";
import {DeleteThemaryCourses, DeleteSubclassCourses} from "../../../services/CoursesServices";

const FormPartThree = React.forwardRef((props, ref) => {
   const {currentThemary, getThemary, updateSubclass} = useContext(EditCourseContext);
   const [themaryList, setThemary] = useState([
      {
         idTemaryClasses: nextId(),
         title: "Clase 1",
         data: [{name: "", idTemarySubclasses: "c" + nextId()}],
      },
   ]);
   const [isSaving, setSaving] = useState("");
   const [isLoading, setLoading] = useState(false);
   const [validThemes, setValidThemes] = useState([]);
   let history = useHistory();
   let {id} = useParams();

   useEffect(() => {
      getThemary();
   }, []);

   useEffect(() => {
      if (currentThemary.data.length > 0) {
         setThemary(currentThemary.data);
      } else {
         setThemary([
            {
               idTemaryClasses: nextId(),
               title: "",
               data: [{name: "", idTemarySubclasses: "c" + nextId(), isNew: true}],
               isNew: true,
            },
         ]);
      }
   }, [currentThemary]);

   useEffect(() => {
      if (validThemes.length >= 1) {
         saveThemeByIndex(0);
      }
   }, [validThemes]);

   const addTheme = () => {
      let newClass = {
         idTemaryClasses: nextId(),
         title: "",
         data: [{name: "", idTemarySubclasses: "c" + nextId(), isNew: true}],
         isNew: true,
      };
      setThemary([...themaryList, {...newClass}]);
   };
   const deleteTheme = (id) => {
      setSaving(true);
      let the = themaryList.find((themm) => themm.idTemaryClasses === id);
      if (the.isNew) return remover();
      DeleteThemaryCourses(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            remover();
         })
         .then(() => {
            setSaving(false);
         })
         .catch((e) => {
            setSaving(false);
            console.log(e);
         });

      function remover() {
         let newThemes = themaryList.filter((item) => {
            return item.idTemaryClasses !== id;
         });
         setThemary(newThemes);
      }
   };

   const addClass = (id) => {
      let cleanClass = {name: "", idTemarySubclasses: "c" + nextId(), isNew: true};
      let newThemes = themaryList.map((item) => {
         if (item.idTemaryClasses === id) {
            let newClasses = [...item.data, {...cleanClass}];
            let newItem = {...item, data: [...newClasses]};
            return newItem;
         }
         return item;
      });
      setThemary(newThemes);
   };

   const deleteClass = (idTheme, idClass) => {
      setSaving(true);
      let the = themaryList.find((themm) => themm.idTemaryClasses === idTheme);
      let classExist = the.data.find((cls) => cls.idTemarySubclasses === idClass);
      if (classExist.isNew) return remover();

      DeleteSubclassCourses(idClass)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            remover();
         })
         .then(() => {
            setSaving(false);
         })
         .catch((e) => {
            setSaving(false);
            console.log(e);
         });

      function remover() {
         let newThemes = themaryList.map((item) => {
            if (item.idTemaryClasses === idTheme) {
               let newClasses = item.data.filter((cla) => cla.idTemarySubclasses !== idClass);
               let newItem = {...item, data: [...newClasses]};
               return newItem;
            }
            return item;
         });
         setThemary(newThemes);
      }
   };

   const setVal = (id, target, val) => {
      let newThema = themaryList.map((item) => {
         if (id === item.idTemaryClasses) {
            return {...item, [target]: val};
         }
         return item;
      });
      setThemary(newThema);
   };

   const changeClass = (idTheme, idClass, val) => {
      let newThemes = themaryList.map((item) => {
         if (item.idTemaryClasses === idTheme) {
            let newClasses = item.data.map((itemClass) => {
               if (itemClass.idTemarySubclasses === idClass) {
                  return {...itemClass, name: val};
               }
               return itemClass;
            });
            let newItem = {...item, data: [...newClasses]};
            return newItem;
         }
         return item;
      });
      setThemary(newThemes);
   };

   const saveThemary = () => {
      setLoading(true);
      let isPossible = true;
      let listValid = themaryList.map((them) => {
         if (them.title) {
            isPossible = !isPossible ? false : true;
            return {...them, valid: true};
         } else {
            let needSave = false;
            them.data.map((cla) => {
               if (!needSave) {
                  if (cla.name.length > 0) {
                     console.log("Tiene textp, neccesita titulo", cla.name);
                  }
                  needSave = cla.name.length > 0;
                  console.log("current name", cla.name, needSave);
               }

               return cla;
            });
            // console.log("Alguno tiene texto", needSave);
            isPossible = needSave ? false : true;
            return {...them, valid: isPossible};
         }
      });
      if (isPossible) {
         // console.log("Se puede enviar", isPossible);
         setValidThemes(listValid);
      } else {
         setThemary(listValid);
         setLoading(false);
      }
   };

   const saveThemeByIndex = (inde) => {
      if (inde === validThemes.length - 1) {
         // console.log("ES EL ULTIMO TEMA");
         saveTheme(validThemes[inde], inde);
      } else if (inde < validThemes.length - 1) {
         // console.log("FAltan por guardar");
         saveTheme(validThemes[inde], inde);
      } else {
         getThemary();
         setLoading(false);
         // props.continue();
      }
   };

   const saveTheme = (val, ind) => {
      setSaving(`Guardando: ${val.title}`);

      if (val.isNew) {
         let toSend = {
            idCourse: Number(id),
            title: val.title,
         };
         CreateThemeCourse(toSend)
            .then((res) => res.json())
            .then((resp) => {
               const {status, data} = resp;
               if (status === "error") throw new Error();
               recorrerClases(data.idTemaryClasses);
            })
            .catch((e) => {
               saveThemeByIndex(ind + 1);
            });
      } else {
         let toSend = {
            idCourse: Number(id),
            title: val.title,
            idTemaryClasses: val.idTemaryClasses,
         };
         let onBase = currentThemary.data.find((Themary) => Themary.idTemaryClasses === val.idTemaryClasses);
         if (onBase) {
            if (onBase.title === val.title) {
               recorrerClases(val.idTemaryClasses);
            }
         } else {
            UpdateThemeCourse(toSend)
               .then((res) => res.json())
               .then((resp) => {
                  const {status, data} = resp;
                  if (status === "error") throw new Error();
                  recorrerClases(val.idTemaryClasses);
               })
               .catch((e) => {
                  console.log(e);
               });
         }
      }
      function recorrerClases(idTemaryClasses) {
         if (!val.data || val.data.length === 0) {
            return saveThemeByIndex(ind + 1);
         }
         for (let nClas in val.data) {
            nClas = Number(nClas);
            saveClass(val.data[nClas], idTemaryClasses);
            if (nClas + 1 === val.data.length) {
               saveThemeByIndex(ind + 1);
            }
         }
      }
   };

   const saveClass = (val, idTemaryClasses) => {
      if (val.isNew) {
         let toSend = {
            idTemaryClasses,
            name: val.name,
         };
         // console.log("GUARDAR", toSend);
         CreateSubthemeCourse(toSend)
            .then((res) => res.json())
            .then((resp) => {
               const {status, data} = resp;
               if (status === "error") throw new Error();
               console.log(val.name, data);
            })
            .catch((e) => {
               console.log(e);
            });
      } else {
         if (val.name) {
            let toSend = {
               idTemaryClasses,
               name: val.name,
               ...val,
            };
            updateSubclass(toSend);
         }
      }
   };

   return (
      <>
         <AllGrid>
            <Col large={12}>
               <TitleSecion>Temarío de curso:</TitleSecion>
            </Col>
            <Grid>
               {React.Children.toArray(
                  themaryList.map((item) => {
                     return (
                        <Col large={3.5}>
                           <SessionsList
                              dataClass={item}
                              change={setVal}
                              addClass={addClass}
                              deleteTheme={deleteTheme}
                              deleteClass={deleteClass}
                              changeClass={changeClass}
                           />
                        </Col>
                     );
                  }),
               )}
               <Col large="1">
                  <AddButton onClick={addTheme} className="add">
                     <PlusIcon width="1.5em" height="1.5em" className="icon" fill={Color.primary} />
                  </AddButton>
               </Col>
            </Grid>
            <Col large="2" offsetL={10}>
               <AppButton onClick={saveThemary}>Guardar</AppButton>
            </Col>
         </AllGrid>
         <StatusLoader isVisible={isLoading} status={isSaving} />
      </>
   );
});

export default FormPartThree;

const AllGrid = styled(Grid)`
   .sepTop {
      margin-top: 2em;
   }
`;

const TitleSecion = styled.p`
   font-size: 1.5em;
   font-weight: 400;
   color: #1c355e;
   margin: 1em 0 1.5em 0;
`;

const AddButton = styled.button`
   display: flex;
   align-items:center;
   justify-content: center;
   background: #32529d;

   border-radius: 50%;
   margin-left: 1em;

   &.add {
      width: 2em;
      height: 2em;
   }

   & .icon {
      // fill: ${Color.primary};
      width: 1em;
      heigth: 1em;
   }
`;

const MediaCol = styled(Col)`
   display: flex;
   align-items: flex-end;

   & ${ResetButton} {
      width: auto;
      padding: 0.3em 0.5em;
      height: fit-content;
      color: crimson;
   }

   .row {
      width: 90%;
   }

   &.sepTop {
      margin-top: 1em;
   }
`;

const Title = styled.p``;

const ClasesText = styled.textarea`
   font-size: 1em;
   font-family: Montserrat;
   resize: none;
   width: 100%;
   height: 120px;
   margin: 0.5em 0;
`;
